import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.textDecoration
import org.jetbrains.compose.web.dom.*
import androidx.compose.runtime.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.await
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.attributes.InputType
import org.w3c.fetch.RequestInit
import org.w3c.dom.events.*


@Composable
fun ContactSection() {
    var name by remember { mutableStateOf("") }
    var email by remember { mutableStateOf("") }
    var messageTitle by remember { mutableStateOf("") }
    var message by remember { mutableStateOf("") }
    var phone by remember { mutableStateOf("") }

    var isLoading by remember { mutableStateOf(false) }
    var isSuccess by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }

    fun validateForm(): Boolean {
        return when {
            name.isBlank() -> { errorMessage = "Name is required"; false }
            email.isBlank() || !email.contains("@") -> { errorMessage = "Valid email is required"; false }
            messageTitle.isBlank() -> { errorMessage = "Message title is required"; false }
            message.isBlank() -> { errorMessage = "Message is required"; false }
            else -> true
        }
    }

    fun submitForm() {
        if (validateForm()) {
            isLoading = true
            errorMessage = null
            MainScope().launch {
                try {
                    sendForm(name, email, messageTitle, message, phone)
                    isSuccess = true
                } catch (e: Exception) {
                    errorMessage = "Submission failed. Please try again."
                } finally {
                    isLoading = false
                }
            }
        }
    }

    Section({
        id("Contact")
        style {
            padding(32.px)
            textAlign("center")
        }
    }) {
        H2 { Text("Contact Me") }

        // Form fields
        Div {
            InputField(label = "Name *", value = name, onChange = { name = it })
            InputField(label = "Email *", value = email, onChange = { email = it }, type = "email")
            InputField(label = "Message Title *", value = messageTitle, onChange = { messageTitle = it })
            TextAreaField(label = "Message *", value = message, onChange = { message = it })
            InputField(label = "Phone (Optional)", value = phone, onChange = { phone = it }, type = "tel")
        }

        // Submit button and status
        if (isLoading) {
            P { Text("Submitting...") }
        } else {
            Button(attrs = {
                onClick { submitForm() }
            }) { Text("Submit") }
        }

        if (isSuccess) {
            P { Text("Thank you! Your message has been submitted.") }
        }

        errorMessage?.let {
            P({ style { color(Color.red) } }) { Text(it) }
        }
    }
}

@Composable
fun InputField(label: String, value: String, onChange: (String) -> Unit, type: String = "text") {
    Div({
        style {
            marginBottom(16.px) // Increased spacing for better separation
        }
    }) {
        Label(label, {
            style {

                display(DisplayStyle.Block)

                fontWeight("bold") // Bold label for emphasis
                color(Color("#333")) // Darker label color for better readability
            }
        }){
            Text(label)
        }

        Input(InputType.Text) {
            attr("type", type) // Specify the input type (e.g., text, email, etc.)
            value(value) // Set the input value
            onInput { event -> onChange(event.value) }
            style {
                property("width", "60%") // Full width
                padding(10.px) // Padding for better touch target
                borderRadius(4.px) // Rounded corners
                property("transition", "border-color 0.2s") // Use property instead of transition
            }
            // Add focus effects
            onFocus {
                style {
                    property("border", "1px solid #007BFF") // Change border color on focus
                }
            }
        }
    }
}

@Composable
fun TextAreaField(label: String, value: String, onChange: (String) -> Unit) {
    Div({
        style {
            marginBottom(16.px) // Increased spacing for better separation
        }
    }) {
        Label(label, {
            style {
                display(DisplayStyle.Block)
                // Space between label and textarea
                fontWeight("bold") // Bold label for emphasis
                color(Color("#333")) // Darker label color for better readability
            }
        }){
            Text(label)
        }

        TextArea(value = value, attrs = {
            onInput { onChange(it.value) }
            style {
                property("width", "60%") // Full width
                height(100.px) // Set a height for the textarea
                padding(10.px) // Padding for better touch target
                borderRadius(4.px) // Rounded corners
                property("transition", "border-color 0.2s") // Use property instead of transition
            }
            // Add focus effect
            onFocus {
                style {
                    property("border", "1px solid #007BFF") // Change border color on focus
                }
            }
        })
    }
}



suspend fun sendForm(name: String, email: String, messageTitle: String, message: String, phone: String) {
    val url ="https://rb7f68qjr0.execute-api.us-east-1.amazonaws.com/v1/email"

    // Manually constructing the form data as a JSON string
    val formData = """
        {
            "name": "$name",
            "email": "$email",
            "message":"$message",
            "phone":"$phone",
            "messageTitle": "$messageTitle"
           
        }
    """.trimIndent()

    // Sending the form data using fetch API
    val response = window.fetch(url, object : RequestInit{
        override var method: String? = "POST"
        override var headers: dynamic =  js("{ 'Content-Type': 'application/json' }")
        override var body = formData
    }).await()

    // Handling non-OK responses
    if (!response.ok) {
        throw Exception("Failed to send form: ${response.statusText}")
    }
}

//@Composable
//fun ContactSection() {
//    Section({
//        id("Contact")
//        style {
//            padding(32.px)
//            textAlign("center")
//        }
//    }) {
//        H2 { Text("Contact Me") }
//        P { Text("Email: android.dev@example.com") }
//        P {
//            A(href = "https://linkedin.com/in/androiddev", attrs = {
//                style { textDecoration("none") }
//            }) {
//                Text("LinkedIn")
//            }
//        }
//        P {
//            A(href = "https://github.com/androiddev", attrs = {
//                style { textDecoration("none") }
//            }) {
//                Text("GitHub")
//            }
//        }
//    }
//}
